import { Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { DecisionGridBankruptcyService } from 'src/app/decision-grid/Services/decision-grid-bankruptcy.service';
import { ScreeningAdditionalData } from 'src/app/models/screeningInvite';

@Component({
  selector: 'app-decision-grid-bk-settings-read',
  templateUrl: './decision-grid-bk-settings-read.component.html',
  styleUrls: ['./decision-grid-bk-settings-read.component.less']
})
export class DecisionGridBkSettingsReadComponent {
  @Input() pkg : ScreeningAdditionalData;
  bkrSub$: Subscription;

  public constructor(public bkr : DecisionGridBankruptcyService){}
  ngOnDestroy(): void {
    if(this.bkrSub$) this.bkrSub$.unsubscribe();

  }
  ngOnInit(): void {
    this.bkrSub$ = this.bkr.getBankruptcySettings(this.pkg.clientId).subscribe();
  }
}
